import template from './rw-actions-dropdown.html';

@Inject('gettextCatalog')
class RwActionsDropdownController {
  $onInit(){
    this.label = this.label || this.gettextCatalog.getString('Actions');
  }
}

export default class RwActionsDropdownComponent {
  constructor() {
    this.template = template;
    this.controller = RwActionsDropdownController;
    this.bindings = {
      label: '@',
      items: '<',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-actions-dropdown/rw-actions-dropdown-component.js